import * as React from 'react';

import Layout from 'components/Layout';
import SEO from 'components/SEO';

import Hero from 'pageComponents/Privacy/Hero';
import Content from 'pageComponents/Privacy/Content';

const PrivacyPage = () => {
  return (
    <Layout>
      <Hero />
      <Content />
    </Layout>
  );
};

export default PrivacyPage;

export function Head({ location }) {
  return (
    <SEO title="Privacy" description="Privacy Policy." location={location} />
  );
}
